<mat-nav-list class="navigation-menu-panel" *ngIf="!(breakpointObserverService.isMobile | async)">
  <!-- The full horizontal lockup, not the standalone mark: this rail is the
       app's only logo whenever it is on screen, because app-top-nav hides its
       own copy at exactly these widths (see that component's
       sidenav-rail-visible mixin). Plain <img>, matching app-top-nav, rather
       than app-icon/MatIconRegistry - the SVG carries id-referenced gradients
       that collide when the same markup is inlined more than once. -->
  <a routerLink="/" class="logo-lockup" aria-label="Map AI home">
    <img src="assets/icons/logo-horizontal.svg" alt="Map AI" width="141" height="68"/>
  </a>

  <div class="desktop-pointer">
<!--    <app-icon svgIcon="pointer"></app-icon>-->
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank" matTooltip="Home" matTooltipPosition="right">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink
       routerLink="/"
       [class.active-link]="isActiveWithQueryParams('/')"
       matTooltip="Explore the interactive map"
       matTooltipPosition="right"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="home"
      ></app-icon>
      <span>Home</span>
    </a>

    <a #navLink
       [routerLink]="'chat'"
       matTooltip="Ask AI about any location"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="ai_chat"
      ></app-icon>
      <span>AI Chat</span>

    </a>

    <a #navLink
       [routerLink]="'reports'"
       matTooltip="Download a full location analysis as PDF"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="report"
      ></app-icon>
      <span>Order report</span>

    </a>

    <a #navLink
       [routerLink]="salesForecastBasePath"
       matTooltip="Choose a perfect location for your business"
       matTooltipPosition="right"
       routerLinkActive="active-link"
       [routerLinkActiveOptions]="{ exact: false }"
       app-icon-button iconSize="22px">
      <app-icon
        svgIcon="site-selection"
      ></app-icon>
      <span>Sales Forecast</span>
    </a>

  </div>

  <div class="user-icon-container">
    <a *ngIf="accessService.getIsAdmin()"
       #navLink
       [routerLink]="'admin'"
       matTooltip="Manage users and platform settings" matTooltipPosition="right"
    >
      <app-icon
        routerLinkActive="active-link"
        svgIcon="adminPanel"
        class="admin-icon"
      ></app-icon>
    </a>
    <a #navLink class="user-icon-circle" routerLinkActive="active-link" [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" [matTooltip]="authService.hasAccessToken() ? 'Manage your subscription and account' : 'Log in to access premium features'" matTooltipPosition="right">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        class="user-icon"></app-icon>
    </a>
  </div>
</mat-nav-list>

<nav class="navigation-menu-panel-mobile" *ngIf="breakpointObserverService.isMobile | async" >
  <!-- Single sliding pointer for mobile -->
  <div class="mobile-pointer">
  </div>

  <div class="navmenu-links">
<!--    <a href="http://map-ai.co" target="_blank">-->
<!--      <app-icon svgIcon="home"></app-icon>-->
<!--    </a>-->

    <a #navLink routerLink="/">
      <app-icon
        svgIcon="home"
        [class.active-link]="isActiveWithQueryParams('/')"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'chat'" class="user-icon">
      <app-icon
        [svgIcon]="'ai_chat'"
        [class.active-link]="isActiveWithQueryParams('/chat')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="authService.hasAccessToken() ? 'user' : 'sign-in'" class="user-icon">
      <app-icon
        [svgIcon]="authService.hasAccessToken() ? 'user' : 'logIn'"
        [class.active-link]="isActiveWithQueryParams('/user')"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a *ngIf="accessService.getIsAdmin()"
       #navLink
       [routerLink]="'/admin'">
      <app-icon
        svgIcon="adminPanel"
        routerLinkActive="active-link"
        class="admin-icon"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'/' + salesForecastBasePath">
      <app-icon
        svgIcon="site-selection"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

    <a #navLink [routerLink]="'/reports'">
      <app-icon
        svgIcon="report"
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: false }"
      ></app-icon>
    </a>

  </div>
</nav>
